const RightArrow = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 11L8.5 6L3.5 1"
      stroke="#F8F8F8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default RightArrow;
